import { Box } from '@chakra-ui/react';
import Profile from '@/components/Templates/Profile';

const ProfilePage = () => {
	return (
		<Box p={{ base: 4, md: 8 }} bg="brand.pageBackground">
			<Box maxW="7xl" mx="auto">
				<Profile />
			</Box>
		</Box>
	);
};

export default ProfilePage;
